import { Box, ListItem, Typography } from '@mui/material'
import TruncatedText from './TruncatedText' // adjust path as needed
import { ReactElement } from 'react'

interface ViewEntityRowProps {
    label: string
    children: React.ReactNode
    isBold?: boolean
    isColonVisible?: boolean
    wrapContent?: boolean
}

const ViewEntityRow = ({
    label,
    children,
    isBold = true,
    isColonVisible = true,
    wrapContent = false,
}: ViewEntityRowProps): ReactElement => {
    return (
        <ListItem
            sx={{
                alignItems: 'flex-start',
                paddingLeft: '0px',
                paddingRight: '0px',
            }}
        >
            <Box sx={{ width: '40%' }}>
                <TruncatedText
                    sx={{
                        fontSize: '14px',
                        fontWeight: isBold ? 600 : 400,
                    }}
                    text={label}
                />
            </Box>
            {isColonVisible && (
                <Box>
                    <Typography
                        sx={{
                            marginRight: '10px',
                            marginLeft: '10px',
                            fontSize: '14px',
                            fontWeight: isBold ? 600 : 400,
                        }}
                    >
                        :
                    </Typography>
                </Box>
            )}
            <Box
                sx={{
                    maxWidth: 'calc(60% - 25px)',
                    display: wrapContent ? 'flex' : 'block',
                    flexWrap: wrapContent ? 'wrap' : 'nowrap',
                    gap: wrapContent ? '5px 0px' : 0,
                }}
                id={label}
            >
                {children}
            </Box>
        </ListItem>
    )
}

export default ViewEntityRow
